var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"response"},[_c('h2',[_vm._v("Response from "+_vm._s(_vm.activeResponse.user_full_name || 'Anonymous')+" on "+_vm._s(_vm.formatDateLong(_vm.activeResponse.updated_at)))]),_vm._v(" "),(_vm.activeResponse.formatted_response)?[_c('survey-response',{attrs:{"pages":_vm.activeResponse.formatted_response.pages}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }